<svg [class.primary]="color === 'primary'"
		 [class.secondary]="color === 'secondary'"
		 [class.default]="color == 'default'"
		 [class.disabled]="color === 'disabled'"
		 [class.enabled]="color === 'enabled'"
		 [class.create]="color === 'create'"
		 [class.dark]="color ==='dark'"
		 [class.grey]="color ==='grey'"
		 [class.red]="color === 'red'"
		 [class.darkblue]="color ==='darkblue'"
		 [class.white]="color === 'white'"
		 [class.black]="color ==='black'"
		 [class.stroked]="color === 'stroked'"
		 [class.reversed]="reverse !== undefined"
		 [class.inclined]="incline !== undefined"
		 [style.width]="width"
		 [style.height]="height">
	<radialGradient *ngIf="gradient" id="radial-gradient"
									[attr.r]="gradient.r"
									[attr.cx]="gradient.cx"
									[attr.cy]="gradient.cy"
									[attr.fx]="gradient.fx"
									[attr.fy]="gradient.fy">
		<stop *ngFor="let property of gradient.colors"
					[attr.stop-color]="property.stopColor"
					[attr.offset]="property.offset" />
	</radialGradient>
	<use [attr.xlink:href]="pathSprite" [attr.fill]="gradient !== null ? 'url(#radial-gradient)' : null"></use>
</svg>
